// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  It applies to page with side bar.
  Example: systemParams -> systemParams.component.scss
*/
/*
  It applies to the title (header) of page content body.
*/
/*
  It describes common behavior on mouse hover.
*/
/*
  It describes light shadow for any page block.
*/
/*
  It applies to entity block like project, facility which has own title, edit button and body.
*/
/*
  It applies together with entity-card mixin, which has been described above
*/
/*
  It applies together with 'entity-card' mixin, which has been described above.
*/
/*
  It applies together with 'entity-card' mixin, which has been described above.
*/
.header {
  display: flex;
  font-weight: normal;
  font-size: 24px;
  font-family: GothamBold, sans-serif;
  font-weight: normal;
  margin-bottom: 10px;
  justify-content: space-between;
}

.systems-table {
  margin-bottom: 20px;
}

.overview {
  margin: 20px;
}

.systems-header {
  display: flex;
  justify-content: space-between;
  font-weight: normal;
  font-size: 16px;
  font-family: GothamBold, sans-serif;
  margin: 20px;
}

.status-filter {
  margin: 0 20px;
}

.facility-systems-list-wrapper {
  justify-content: left;
}

.placeholder {
  margin: 20px;
}

.config-selected {
  margin-left: 20px;
  margin-bottom: 50px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
